import type { FunctionComponent } from 'react';
import SidebarNavLayout from '../../layouts/SidebarNavLayout';
import SettingsPage from '../../shared/settings/SettingsPage';
import * as permissions from '../shared/permissions';
import type { RouterProps } from '../../../types';
import Flex from '../../generic/Flex';
import PaidPill from '../../generic/Pill/PaidPill';
import { isFreeTier } from '../../../../shared/subscriptions';
import { window } from '../../../globals';

type Props = RouterProps;

/**
 * OrganizationIntegrationSettings is the top-level wrapper component for
 * all the integration settings pages.
 */
const OrganizationIntegrationSettings: FunctionComponent<Props> = ({ children, location }) => {
  return (
    <SidebarNavLayout>
      <SidebarNavLayout.Nav pathname={location.pathname}>
        <SidebarNavLayout.NavHeading>
          Integrations
        </SidebarNavLayout.NavHeading>
        {permissions.shouldDisplayJiraSettings() && (
          <SidebarNavLayout.NavItem to="/account/settings/integrations/jira" activeKey="jira">
            <Flex justify="space-between">
              Jira
              {isFreeTier({
                plan: window.user?.organization?.stripe_plan,
                stripePriceLimit: window.user?.organization?.stripePriceLimit,
              }) && <PaidPill />}
            </Flex>
          </SidebarNavLayout.NavItem>
        )}
        <SidebarNavLayout.NavItem to="/account/settings/integrations/github" activeKey="github">
          GitHub
        </SidebarNavLayout.NavItem>
        {permissions.shouldDisplaySlackSettings() && (
          <SidebarNavLayout.NavItem to="/account/settings/integrations/slack" activeKey="slack">
            <Flex justify="space-between">
              Slack
              {isFreeTier({
                plan: window.user?.organization?.stripe_plan,
                stripePriceLimit: window.user?.organization?.stripePriceLimit,
              }) && <PaidPill />}
            </Flex>
          </SidebarNavLayout.NavItem>
        )}
        <SidebarNavLayout.NavItem to="/account/settings/integrations/bitbucket" activeKey="bitbucket">
          Bitbucket
        </SidebarNavLayout.NavItem>
        <SidebarNavLayout.NavItem to="/account/settings/integrations/gitlab" activeKey="gitlab">
          GitLab
        </SidebarNavLayout.NavItem>
        <SidebarNavLayout.NavItem to="/account/settings/integrations/api_tokens" activeKey="api_tokens">
          API
        </SidebarNavLayout.NavItem>
        {permissions.shouldDisplayCustomLicenseScanSettings() && (
          <SidebarNavLayout.NavItem to="/account/settings/integrations/custom_license_scans" activeKey="custom_license_scans">
            Custom License Scans
          </SidebarNavLayout.NavItem>
        )}
      </SidebarNavLayout.Nav>
      <SidebarNavLayout.Content>
        <SettingsPage>
          {children}
        </SettingsPage>
      </SidebarNavLayout.Content>
    </SidebarNavLayout>
  );
};

export default OrganizationIntegrationSettings;
